import { render, staticRenderFns } from "./audioPlayer.vue?vue&type=template&id=6ba43233&scoped=true"
import script from "./audioPlayer.vue?vue&type=script&lang=js"
export * from "./audioPlayer.vue?vue&type=script&lang=js"
import style0 from "./audioPlayer.vue?vue&type=style&index=0&id=6ba43233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba43233",
  null
  
)

export default component.exports